import {Injectable} from '@angular/core';
import {BehaviorSubject, Subscription} from 'rxjs';
import {Message} from 'src/app/core/class/message';
import {ToastrService} from 'ngx-toastr';
import {ApiService} from "./api.service";

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  public notification: BehaviorSubject<any>;
  public errorCode: BehaviorSubject<any>;
  public error = '';
  public subscription: Subscription;
  private noAccessToContract = new BehaviorSubject(null);
  public changePassword = new BehaviorSubject(false);

  constructor(
    private message: Message,
    private toastr: ToastrService,
    private apiService: ApiService
  ) {
    this.notification = new BehaviorSubject<any>('');
    this.errorCode = new BehaviorSubject<any>('');
  }

  getNotification() {
    return this.notification.asObservable();
  }

  notify(message) {
    this.notification.next(message);
  }

  setErrorCode(errorCode: string) {
    this.errorCode.next(errorCode);
  }

  resetErrorCode() {
    this.errorCode = new BehaviorSubject<any>('');
  }

  getErrorCode() {
    return this.errorCode.asObservable();
  }

  emitChangePassword(message){
    this.changePassword.next(message);
  }

  subscribeErrorService() {
    this.error = '';
    this.notify('');
    this.subscription = this.getNotification().subscribe(
      message => {
        if (message === '') {
          this.error = '';
          return;
        } else {
          window.scroll(0, 0);
          if (!this.toastr.findDuplicate(message, true, true)) {
            // fix bug null pointer
            if (this.apiService && this.apiService.event && this.apiService.event.body && this.apiService.event.body.code != '0x00133') {
              if (message) {
                this.toastr.error(message);
              }
            }
          }
        }
      }
    );
  }

  /**
   * Unsubscribe error service
   */
  unsubscribeErrorService() {
    this.error = '';
    this.notify('');
    this.subscription.unsubscribe();
  }

  /**
   * set error service No Access To Contract
   */
  setAvailableNoAccess(code: any) {
    this.noAccessToContract.next(code);
  }

  /**
   * get error service No Access To Contract
   */
  getAvailableNoAccess() {
    return this.noAccessToContract.asObservable();
  }
}
